import { render } from "./section8.vue?vue&type=template&id=23740d55&scoped=true"
const script = {}

import "./section8.vue?vue&type=style&index=0&id=23740d55&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23740d55"]])

export default __exports__